module.exports = __webpack_public_path__ + "static/media/AboutUsActive.31e07176.svg";